module.exports = __webpack_public_path__ + "images/twitter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitter.svg
// module id = 1132
// module chunks = 0